// GOLDEN PATH CODE
// This is an RFE Step Mesh Module based on best practices from
// AWT (https://awt.aws.dev/mesh/guide/introduction.html)
// It defines a migration step for RFE
import { defineModule, defineModuleMetadata } from "@amzn/awt-module-api";
import { defineViewTypes } from "@amzn/awt-module-views";
import { provideReactViewTypeHandler } from "@amzn/awt-module-views-react-18";
import {
  websiteContributions,
  websiteId,
  WorkflowModuleProps,
} from "@amzn/region-flex-interface-module-website-common";
import { MigrationStep } from "../components/MigrationStep";

// Golden Path Note:
// Modules should be named in the form @amzn/rfp-{nodeId}, where the
// nodeId matches the id of the workflow node that this step will be managing
export const nodeId = "migration-step";
export const moduleId = `${websiteId}-${nodeId}`;

export const viewTypes = defineViewTypes(moduleId, ({ withProps }) => ({
  stepView: withProps<WorkflowModuleProps>(),
}));

export const metadata = defineModuleMetadata(
  {
    moduleId,
    moduleVersion: "1.0.0",
  },
  // Golden Path Note:
  // These contributions enable the other modules to know which
  // migration steps the module is responsible for
  ({ contribute }) => {
    contribute(websiteContributions.migrationStep, [
      websiteContributions.migrationStep.create({
        nodeId,
        view: viewTypes.stepView,
      }),
    ]);
  }
);

export const Step = (props: WorkflowModuleProps) => <MigrationStep {...props} />;

export const module = defineModule({
  activate: (moduleContext) => {
    provideReactViewTypeHandler({
      moduleContext,
      viewTypeDefinition: viewTypes.stepView,
      componentProvider: async () => Step,
      on: {
        error: ({ error }) => console.error(error),
      },
    });
  },
});
